import urls from '../constants/urls';
import { SWITCH_API_CLIENT } from '../middleware/multiClientHandler';

export const REVOKING_USER = 'switchapi/revokeUser/REVOKING_USER';
export const REVOKE_USER_SUCCESS = 'switchapi/revokeUser/REVOKE_USER_SUCCESS';
export const REVOKE_USER_FAILED = 'switchapi/revokeUser/REVOKE_USER_FAILED';

const initialState = {
  initialLoading: true,

  failedRevoking: false,

  hasRevoked: false,

  isRevoking: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REVOKING_USER:
      return {
        ...state,
        failedRevoking: false,
        isRevoking: true,
      };

    case REVOKE_USER_SUCCESS:
      return {
        ...state,
        failedRevoking: false,
        hasRevoked: true,
        isRevoking: false,
      };

    case REVOKE_USER_FAILED:
      return {
        ...state,
        failedRevoking: true,
        isRevoking: false,
      };

    default:
      return state;
  }
};

export const revokeUser = (workspaceId, inductionId) => dispatch => {
  return dispatch({
    types: [REVOKING_USER, REVOKE_USER_SUCCESS, REVOKE_USER_FAILED],
    payload: {
      customClient: SWITCH_API_CLIENT,
      request: {
        method: 'post',
        url: urls.switchApi.revokeUser.create,
        data: {
          data: { workspace_id: workspaceId, induction_id: inductionId },
        },
      },
    },
  });
};
